import React, { useEffect, useState } from "react";
import { DateFormetContext } from "../../../app/App.js";
import MyModal from "../../../components/MyModal";
import DocumentsNav from "./DocumentsNav/DocumentsNav";
import DocumentsTable from "./DocumentsTable/DocumentsTable";
import StatementDocument from "./StatementDocument";
function Documents({
  filter,
  onStatusChange,
  sortCharged,
  viewDocument,
  documentData,
  downloadPDF,
  sharePDF,
  fileData,
  file,
  closeNewTaxReport,
  closeNewStatementReport,
  closeCheck,
  viewDocumentHandler,
  downloadFileHandler,
}) {
  const [searchValue, setSearchValue] = useState("");
  const [select, setSelect] = useState("");
  const dateFormet = React.useContext(DateFormetContext);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const [page, setPage] = useState(0);

  useEffect(() => {
    setPage(0);
  }, [searchValue, endDate])

  const filter_by = [
    "All",
    "Statements",
    "Tax Reports",
    "Invoices",
    "Receipts",
  ];
  const filterTabs = [
    {
      title: "All",
      value: "All",
    },
    {
      title: "Statements",
      value: "Statements",
    },
    {
      title: "Tax Reports",
      value: "Tax Reports",
    },
    {
      title: "Invoices",
      value: "Invoices",
    },
    {
      title: "Receipts",
      value: "Receipts",
    }
  ];
  return (
    <>
      <DocumentsNav
        filter={filter}
        setSearchValue={setSearchValue}
        searchValue={searchValue}
        filter_by={filter_by}
        filterTabs={filterTabs}
        onStatusChange={onStatusChange}
        handleSelect={setSelect}
        startDate={startDate}
        endDate={endDate}
        DateRange={setDateRange}
      />
      <DocumentsTable
        filters={filter}
        searchValue={searchValue}
        setPage={setPage}
        page={page}
        sortCharged={sortCharged}
        viewDocument={viewDocument}
        documentData={documentData}
        startDate={startDate}
        endDate={endDate}
        dateRange={dateRange}
        downloadPDF={downloadPDF}
        sharePDF={sharePDF}
        fileData={fileData}
        file={file}
        closeNewTaxReport={closeNewTaxReport}
        closeNewStatementReport={closeNewStatementReport}
        closeCheck={closeCheck}
        dateFormet={dateFormet}
        viewDocumentHandler={viewDocumentHandler}
        downloadFileHandler={downloadFileHandler}
        onStatusChange={onStatusChange}
      />
    </>
  );
}

export default Documents;
